module.exports = __webpack_public_path__ + "img/meeting.47cc3391.svg";